import React from 'react'
import Sidebar from '../../Components/Sidebar'
import TopHeader from '../../Components/TopHeader'
import ContactInfo from './ContactInfo'
import BannerPage from '../../Components/Banner'


export default function ContactUs() {
  return (

    <div id="admin-dashboard" className="flex h-[800px] bg-neutral-100">

      <Sidebar />

      {/* <!-- Main Content Area --> */}
      <div id="main-content" className="flex-1 flex flex-col overflow-hidden">
        {/* <!-- Top Navigation Bar --> */}
        <TopHeader pageName="Contact Us" />

        {/* <!-- Content Container --> */}
        <div id="content-container" className="flex-1 overflow-auto p-6">
          {/* <!-- Page Header --> */}
          {/* <PageHeader /> */}
          <BannerPage pageName={'contactUs'} />
          <ContactInfo />
        </div>
      </div>
    </div>
  )
}
